import { IkeEnvironment, IkeSystem } from '@ikegps/core-api';
import { IkeConfig } from '../..';
import { OfficeBase } from './office.base';

export const OfficeTest = new IkeConfig(IkeSystem.OFFICE, IkeEnvironment.TEST);
const config = OfficeTest;
config.extend(OfficeBase);

OfficeTest.set('config.store', 'test');
OfficeTest.set('vendor.google.maps', 'AIzaSyA_j7Kpx-R8dPxO29kD6Id0EX724Yj_vZc');

/*
 * todo: We are not using these parameters as these are injected from Dragon-Server
 * when building. They are injected in index.html and is a static file
 */
OfficeTest.set('vendor.google.analytics', 'UA-73934200-1');
OfficeTest.set('vendor.google.tagmanager', 'GTM-5BZ5NZJ');
